import styled from 'styled-components';
import { ifProp } from 'styled-tools';

import { IconButton } from 'components/Shared/Buttons';
import { SCAFFOLDING, CARDS, TRANSITION } from 'theme';

const CardTool = styled(IconButton)`
    display: inline-block;
    padding: ${SCAFFOLDING.GUTTER_FACTOR(0.25)};
    cursor: pointer;
    font-size: ${CARDS.ICON.SIZE};
    line-height: 0;
    transition: transform ${TRANSITION.LENGTH} ${TRANSITION.BEZIER};

    ${ifProp(
        'right',
        `
        float: right;
    `
    )}

    &:hover,
    &:focus {
        transform: scale(1.25);
    }
`;

export default CardTool;
